const WORK_LOCATIONS_THAT_REQUIRE_CITIES = ['OFFICE', 'HYBRID'];

export {WORK_LOCATIONS_THAT_REQUIRE_CITIES};
